import React from "react";
import { BadgeCheck, Crown, Sparkles } from "lucide-react";

export default function SpaBadges({ featured, premium, verified, size = "sm" }) {
  const cls = size === "sm" ? "text-[10px] px-2 py-0.5" : "text-xs px-2.5 py-1";
  return (
    <div className="flex flex-wrap items-center gap-1.5">
      {premium && (
        <span className={`${cls} rounded-full inline-flex items-center gap-1 bg-[#111827] text-white`} data-testid="badge-premium">
          <Crown size={11} strokeWidth={2} /> Premium
        </span>
      )}
      {featured && (
        <span className={`${cls} rounded-full inline-flex items-center gap-1 bg-[rgba(201,168,106,0.18)] text-[#7A5A22] border border-[rgba(201,168,106,0.35)]`} data-testid="badge-featured">
          <Sparkles size={11} strokeWidth={2} /> Featured
        </span>
      )}
      {verified && (
        <span className={`${cls} rounded-full inline-flex items-center gap-1 bg-[rgba(31,78,61,0.1)] text-[#1F4E3D] border border-[rgba(31,78,61,0.25)]`} data-testid="badge-verified">
          <BadgeCheck size={11} strokeWidth={2} /> Verified
        </span>
      )}
    </div>
  );
}
